import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenStorageService } from '../app/token-storage.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AlertsService } from '../app/alerts.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private tokenStorage: TokenStorageService, private router: Router, public alertService: AlertsService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Intercepts every http request to the server and adds the JWT token to the header
    if (this.tokenStorage.isAuthenticated() && this.tokenStorage.getToken()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.tokenStorage.getToken()}`
        }
      });
    }

    return next.handle(request).pipe(
      tap({
        next: (event) => { },
        error: (error: HttpErrorResponse) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {
              this.tokenStorage.signOut();
              this.alertService.error("Login expired. Kindly login again!!!");
              this.router.navigate(['login']);
            }
          }
        }
      })
    );
  }
}
